// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-2_fii";
var _3 = "icon-2c0eq";
export { _1 as "__esModule", _2 as "root", _3 as "icon" }
export default { "__esModule": _1, "root": _2, "icon": _3 }
